export default "/images/vendor/flag-icon-css/flags/1x1/et.svg?61822620fbdca0ced26f969dce5b422f";